import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import { EvkMapasComponent } from '../../../../../wizard/componentes/section/sub-components/evk-mapas/evk-mapas.component';
import { Punto } from '../../../../../wizard/componentes/section/sub-components/evk-mapas/mapas/modelos/Punto';
import { EvkMapasService } from '../../../../../wizard/componentes/section/sub-components/evk-mapas/evk-mapas.service';
import { BusquedaEstructuradaNominatim } from '../../../../../wizard/componentes/section/sub-components/evk-mapas/mapas/modelos/BusquedaEstructuradaNominatim';
import { CroquisSizeConfig } from '../../../../../wizard/componentes/section/sub-components/evk-mapas/mapas/modelos/CroquisSizeConfig';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'lib-datos-georeferencia',
    templateUrl: './datos-georeferencia.component.html',
    styleUrls: ['./datos-georeferencia.component.css']
})
export class DatosGeoreferenciaComponent implements OnInit {
    @Input()
    form: FormGroup;
    @Input()
    formLoc: FormGroup;

    @ViewChild(EvkMapasComponent, {static: false})
    georeferencia: EvkMapasComponent;

    img64: string;

    punto: Punto;

    showMap: boolean = false;

    filters = [
        {
            id: 'municipio',
            title: 'Municipio',
            path: 'municipio',
        },
        {
            id: 'cp',
            title: 'Código Postal',
            path: 'cp',
        },
    ];
    filtroSeleccionado: String;
    constructor(
        private mapaServie: EvkMapasService,
        public fb: FormBuilder
    ) {
    }

    ngOnInit(): void {
        this.formLoc = this.fb.group({
            estado: ['Chihuahua'],
            municipio: [''],
            cp: ['']
        });
        this.mapaServie.dataLatLng.subscribe(data => {
            if (data['lat'] && data['lng']) {
                this.guardarPuntoForm(data['lat'], data['lng'])
            }
        });
        try {
            let previous_style;
            const poll = window.setInterval(function()
            {
                let current_style = document.getElementById('mapa-hide')?.style?.display;
                if (previous_style != current_style) {
                    // alert('style changed');
                    setTimeout(() => window.dispatchEvent(new Event("resize")), 100)
                    window.clearInterval(poll);
                    // setTimeout(()=>this.resizeAndShow(), 100)
                } else {
                    previous_style = current_style;
                }
            }, 100);
        } catch (error) {

        }
    }
    resizeAndShow(){
        this.showMap = true;
        setTimeout(() => window.dispatchEvent(new Event("resize")), 100)
    }
    ngAfterViewInit() {
        console.log(this.form.controls.lat.value);
        console.log(this.form.controls.lng.value);
        if(this.form.controls.lat.value && this.form.controls.lng.value){
            this.georeferencia.buscarPuntoEnElMapaConBusquedaEnReversa(this.form.controls.lat.value, this.form.controls.lng.value).subscribe((features) => {
                if (features && features.features) {
                    this.georeferencia.agregarGeoJsonFeatures(features, true);
                    const punto = this.georeferencia.featuresToPoint(features);
                    if (punto) {
                        this.georeferencia.moverMapaAPunto(punto);
                        this.punto = punto;
                    }
                }
            })
        }
    }

    onFiltroChange($event: MatSelectChange) {
        if ($event.value) {
            this.filtroSeleccionado = $event.value;
        }
        if (!$event.value) {
            this.filtroSeleccionado = undefined;
        }
    }

    get getFormValue(): any {
        return this.formLoc.value;
    }

    public buscarLocalizacion() {
        if (this.getFormValue.estado == "Ciudad De México") {
            // this.busquedaParaCdmx();
        } else {
            this.busquedaParaProvincia();
        }
    }
    public generarImagen() {
        this.georeferencia.obtenerImagenDeMapaComoPng(CroquisSizeConfig.customSize(400, 400)).then((img) => {
            this.img64 = img;
        });
    }
    guardarPuntoForm(latitud: number, longitud: number){
        this.form.controls.lat.setValue(latitud);
        this.form.controls.lng.setValue(longitud);
    }
    public searchValid() {
        if(!this.filtroSeleccionado){
            return true;
        } else if("municipio" === this.filtroSeleccionado){
            return this.getFormValue.municipio === "";
        } else if("cp" === this.filtroSeleccionado){
            return this.getFormValue.cp === "";
        }
    }
    public busquedaParaProvincia() {
        const busqueda = new BusquedaEstructuradaNominatim();
        busqueda.estado = this.getFormValue.estado;
        busqueda.localidad = this.getFormValue.municipio;
        busqueda.cp = this.getFormValue.cp;
        if("municipio" === this.filtroSeleccionado){
            busqueda.cp = "";
        }
        if("cp" === this.filtroSeleccionado){
            busqueda.localidad = "";
        }
        this.georeferencia.buscarPuntoEnElMapaConBusquedaSimple(busqueda).subscribe((features) => {
            if (features && features.features) {
                this.georeferencia.agregarGeoJsonFeatures(features, true);
                const punto = this.georeferencia.featuresToPoint(features);
                if (punto) {
                    this.guardarPuntoForm(punto.latitud, punto.longitud);
                    this.georeferencia.moverMapaAPunto(punto);
                    this.punto = punto;
                }
            }
        })
    }

}
